import { yupResolver } from "@hookform/resolvers/yup";
import { StaticPdfContent } from "api/shop";
import { PaziaFormButton, PaziaInput, PaziaFileDropzone } from "components/atoms";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { useShopImageUpload } from "./useShopImageUpload";

interface StaticPdfFormProps {
  onSubmit: (data: StaticPdfFormValues) => void;
  onCancel: () => void;
  defaultValues?: StaticPdfContent;
  isLoading?: boolean;
}

export const StaticPdfForm = ({ onSubmit, onCancel, defaultValues, isLoading }: StaticPdfFormProps) => {
  const { uploadImage } = useShopImageUpload();
  const methods = useForm<FormValues>({
    resolver: yupResolver(schema) as any,
    defaultValues: {
      pdfFile: defaultValues?.pdfUrl ?? "",
      title: defaultValues?.title ?? "",
    },
  });

  const handleFormSubmit = async (data: FormValues) => {
    const pdfUrl = await uploadImage(data.pdfFile);
    const formattedData: StaticPdfFormValues = {
      pdfUrl,
      title: data.title || undefined,
    };
    onSubmit(formattedData);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleFormSubmit)} className="grid gap-4">
        <PaziaFileDropzone name="pdfFile" type="pdf" label="Plik PDF" single />
        <PaziaInput name="title" label="Tytuł strony (opcjonalnie)" placeholder="np. Regulamin" />

        <div className="flex justify-end gap-2 border-t border-slate-200 pt-4 dark:border-slate-600">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-lg border border-slate-300 px-4 py-2 text-slate-700 transition-colors hover:bg-slate-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700"
          >
            Anuluj
          </button>
          <PaziaFormButton disabled={isLoading} />
        </div>
      </form>
    </FormProvider>
  );
};

const schema = yup
  .object({
    pdfFile: yup.mixed().required("Plik PDF jest wymagany"),
    title: yup.string().optional(),
  })
  .required();

interface FormValues {
  pdfFile: string | File;
  title?: string;
}

export interface StaticPdfFormValues {
  pdfUrl: string;
  title?: string;
}
